// throws a warning if a `requiredByPropName` is not passed when this prop exists
// otherwise, calls the passed propType checker (e.g. PropTypes.bool)
// adapted from https://github.com/airbnb/prop-types/blob/master/src/requiredBy.js
export default function getRequiredBy(requiredByPropName, propType) {
  return (props, propName, componentName, location, propFullName) => {
    if (props[requiredByPropName]) {
      if (typeof props[propName] === 'undefined') {
        return new TypeError(`${componentName}: when ${requiredByPropName} is defined, prop ${propName} must also be defined`);
      }
    }
    return propType(props, propName, componentName, location, propFullName);
  };
}